import React from 'react';
// import MailOutline from "@mui/icons-material/MailOutline";
// import LaunchOutlined from "@mui/icons-material/LaunchOutlined";
// import Grid3x3 from "@mui/icons-material/Grid3x3";
// import PersonOutline from "@mui/icons-material/PersonOutline";
// import LockOutlined from "@mui/icons-material/LockOutlined";
// import BookmarkBorderOutlined from "@mui/icons-material/BookmarkBorderOutlined";
// import InputAdornment from "@mui/material/InputAdornment";
// import { ThemeProvider } from "@emotion/react";
// import TextField from '@mui/material/TextField';
// import { createTheme } from '@mui/material/styles';
// import { withStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import { makeStyles } from '@mui/styles';
import { styled } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  inputText: {
    margin: 'unset',
  },
}));
// const colortheme = createTheme({
//   palette: {
//     error: {
//       main: '#c1c1c1',
//     },
//     primary: {
//       main: '#292739',
//     },
//     secondary: {
//       main: '#c1c1c1',
//     },
//   },
//   typography: {
//     fontFamily: ['lato'].join(','),
//   },
// });

// const CustomTextField = withStyles({
//   root: {
//     margin: '0rem',
//     '& .MuiInputBase-input': {
//       color: '#323232',
//       textAlign: 'center',
//     },
//     '& .MuiInput-root': {
//       fontSize: 'inherit',
//     },
//     '& .MuiInput-root:after': {
//       borderBottom: 'none !important',
//     },
//     '& .MuiInput-root:before': {
//       borderBottom: 'none !important',
//     },
//   },
// })(TextField);

const CustomFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  height: 'fit-content',
  backgroundColor: '#ececec',
  borderRadius: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  padding: '5px',
  // boxShadow: theme.shadows[3]
}));

const CustomTextArea = styled('textarea')(({ theme }) => ({
  fontSize: `inherit`,
  border: 'none',
  outline: 'none',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: '10px',
  resize: 'none',
  backgroundColor: 'transparent',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
}));

interface inputTextProps {
  type?: string;
  style?: object;
  initValue: string;
  ablefunction?: () => void;
  unablefunction?: () => void;
  setInput: (name: string) => void;
  onClick?: (e: any) => void;
}

const SimpleInputCard: React.FC<inputTextProps> = ({
  type,
  initValue,
  style,
  ablefunction,
  unablefunction,
  setInput,
  onClick,
}) => {
  const classes = useStyles();

  // const CheckUser = (e: any): void => {
  //   if (ablefunction && unablefunction) {
  //     e.target.value !== "jane21" ? ablefunction() : unablefunction();
  //     setInput(e.target.value);
  //   }
  // };

  const handleInputHeight = (e: any): void => {
    const input = e.target as HTMLTextAreaElement;
    input.style.height = `auto`;
    input.style.height = `${input.scrollHeight}px`;
  };

  const submitInput = (e: any): void => {
    setInput(e.target.value);
  };

  return (
    <CustomFormControl
      fullWidth
      sx={{ m: 1, ...style, fontSize: `inherit` }}
      variant="standard"
      className={classes.inputText}
    >
      <CustomTextArea
        id="input-with-icon-textfield"
        defaultValue={initValue}
        onBlur={submitInput}
        onChange={e => handleInputHeight(e)}
        onTouchStart={e => {
          e.stopPropagation();
          e.currentTarget.focus();
        }}
      />
    </CustomFormControl>
  );
};

export default SimpleInputCard;
